module.exports = __webpack_public_path__ + "img/Allhouse_LoadingGIF (1).13258d50.gif";